module.exports = __webpack_public_path__ + "img/fgyl.60fc0e32.png";